import { RevealOnScroll } from './Motion';

export default function VideoSection() {
    return (
        <section
            id="video"
            className="relative border-t border-ink/20 py-24 md:py-32"
            data-testid="video-section"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
                <RevealOnScroll>
                    <div className="flex items-baseline justify-between flex-wrap gap-6 mb-12">
                        <div>
                            <div className="text-[11px] uppercase tracking-[0.3em] mb-4 text-ink-600">
                                — شاهد
                            </div>
                            <h2 className="font-display font-black text-4xl md:text-6xl leading-[1.05] tracking-tight">
                                فيديو تعريفي.<br />
                                <span className="italic font-light">دقيقة واحدة.</span>
                            </h2>
                        </div>
                        <div className="max-w-sm text-ink-600 text-sm leading-relaxed">
                            نظرة سريعة على كيفية عمل المنصّة والاستفادة من أفضل
                            الاستطلاعات المدفوعة.
                        </div>
                    </div>
                </RevealOnScroll>

                <RevealOnScroll delay={0.1}>
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
                        <div className="lg:col-span-6 lg:col-start-4">
                            <div
                                className="relative border border-ink bg-ink"
                                style={{ aspectRatio: '9 / 16' }}
                            >
                                <iframe
                                    src="https://www.youtube.com/embed/4eNoE3t64uA?rel=0&modestbranding=1"
                                    title="فيديو تعريفي"
                                    className="absolute inset-0 w-full h-full"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                    data-testid="video-iframe"
                                />
                            </div>
                            <div className="mt-4 flex items-center justify-between text-[11px] uppercase tracking-widest text-ink-400">
                                <span>YouTube Shorts</span>
                                <a
                                    href="https://youtube.com/shorts/4eNoE3t64uA"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-emerald-signal transition-colors"
                                    data-testid="video-external"
                                >
                                    فتح في يوتيوب ↗
                                </a>
                            </div>
                        </div>
                    </div>
                </RevealOnScroll>
            </div>
        </section>
    );
}
